import React from 'react';
import { useDebug } from './debug-provider';
import DebugPill from './debug-pill';
const PageDebug = ({ pageResources }) => {
    const { showTemplateNames } = useDebug();
    if (showTemplateNames) {
        return (React.createElement(DebugPill, null,
            "Template:",
            ' ',
            pageResources.page.componentChunkName));
    }
    return null;
};
export default PageDebug;
//# sourceMappingURL=page-debug.js.map